/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Job_Positions_FoundInputs */

const en_no_job_positions_found = /** @type {(inputs: No_Job_Positions_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No job positions found`)
};

const de_no_job_positions_found = /** @type {(inputs: No_Job_Positions_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Stellenangebote gefunden`)
};

/**
* | output |
* | --- |
* | "No job positions found" |
*
* @param {No_Job_Positions_FoundInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const no_job_positions_found = /** @type {((inputs?: No_Job_Positions_FoundInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Job_Positions_FoundInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_no_job_positions_found(inputs)
	return en_no_job_positions_found(inputs)
});